export const URL_PANEL = 'https://panel.justmenu.es';
// export const URL_PANEL = 'http://menupp.local';
export const URL_SERVICE = URL_PANEL + '/api';